import * as tslib_1 from "tslib";
import { EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap';
import { WebcamImage, WebcamUtil } from 'ngx-webcam';
import { Subject } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { appSettings as globals } from '../../../../../../../../../environments/app.setings';
import { ModalErroValidacaoComponent } from '../../../modal-erro-validacao/modal-erro-validacao.component';
import { ModalValidandoComponent } from '../../../modal-validando/modal-validando.component';
import { ModalDicaDeFotoComponent } from '../modal-dica-de-foto/modal-dica-de-foto.component';
import { ModalInfoAppOmniComponent } from '../modal-info-app-omni/modal-info-app-omni.component';
export class CapturaFotoComponent {
    constructor(modal) {
        this.modal = modal;
        this.isEnabledFotoAndEnviar = true;
        this.celularFoiValidado = false;
        this.showLoader = new EventEmitter();
        this.cancelarBiometria = new EventEmitter();
        this.excluirFicha = new EventEmitter();
        this.finalizarBiometria = new EventEmitter();
        this.ACCEPT_IMAGES = globals.ACCEPT_IMAGES;
        this.hasWebcam = false;
        this.showWebcam = true;
        this.tirouFoto = false;
        this.webcamTrigger = new Subject();
        this.numeroTentativasBiometria = 3;
        this.hasErrorBiometriaAssessment = false;
        this.biometriaAprovada = false;
        this.isAlive = true;
        this.onChange = () => { };
        this.onTouch = () => { };
    }
    ngOnInit() {
        this.initWebcam();
    }
    writeValue(obj) {
        this.selfiePreview = obj;
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouch = fn;
    }
    initWebcam() {
        WebcamUtil.getAvailableVideoInputs()
            .then((mediaDevices) => {
            this.hasWebcam = mediaDevices && mediaDevices.length > 0;
            this.showLoader.emit(false);
            if (!this.hasWebcam) {
                this.cancelarBiometria.emit();
            }
        }).catch((_) => {
            this.showLoader.emit(false);
        });
    }
    handleImageCapture(imagem) {
        if (this.isLojistaPiloto) {
            this.tirouFoto = true;
            this.openModalValidando(imagem);
        }
        this.previewSelfie(imagem);
        this.onChange(imagem);
    }
    onClickTirarUmaFoto() {
        this.showWebcam = !this.showWebcam;
        this.webcamTrigger.next();
    }
    onClickTirarOutraFoto() {
        this.hasErrorBiometriaAssessment = false;
        if (this.numeroTentativasBiometria === 0) {
            this.numeroTentativasBiometria = 3;
        }
        if (this.hasWebcam) {
            this.showWebcam = !this.showWebcam;
            this.onChange(null);
        }
    }
    previewSelfie(imagem) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const imgFile = imagem;
            if (!imgFile) {
                this.selfiePreview = null;
            }
            else if (imgFile instanceof WebcamImage) {
                this.selfiePreview = imgFile.imageAsDataUrl;
            }
            else {
                this.selfiePreview = yield this.readFileAsDataURL(imgFile);
            }
        });
    }
    readFileAsDataURL(file) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.onload = (_) => resolve(fileReader.result);
            fileReader.onerror = (error) => reject(error);
            fileReader.readAsDataURL(file);
        });
    }
    openModalValidando(imagem) {
        const imgFile = imagem;
        let photo;
        if (this.tirouFoto && imgFile instanceof WebcamImage) {
            photo = imgFile.imageAsBase64;
        }
        const initialState = {
            foto: photo,
            proposta: this.propostaId
        };
        const modal = this.modal.show(ModalValidandoComponent, Object.assign({}, globals.MODAL_PARAMS, { initialState }));
        const validou = modal.content;
        validou.onValidar
            .pipe(takeWhile(() => validou.alive)).subscribe(retorno => {
            if (retorno) {
                this.biometriaAprovada = true;
                return;
            }
            this.numeroTentativasBiometria--;
            if (this.numeroTentativasBiometria === 0) {
                this.hasErrorBiometriaAssessment = false;
                return;
            }
            this.handleErrorBiometriaUnico();
        });
    }
    handleErrorBiometriaUnico() {
        this.hasErrorBiometriaAssessment = true;
        this.openModalErroValidacao();
    }
    openModalErroValidacao() {
        const initialState = {
            retornoAssessment: 'Erro ao realizar biometria. Por favor aproxime-se da câmera, centralize o rosto na área de captura e tente novamente!'
        };
        this.modal.show(ModalErroValidacaoComponent, Object.assign({}, globals.MODAL_PARAMS, { initialState }));
    }
    onClickSaibaMais() {
        this.openModalErroValidacao();
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    abrirModalDicaDeFoto() {
        this.modal.show(ModalDicaDeFotoComponent, Object.assign({}, globals.MODAL_PARAMS));
    }
    finalizar() {
        this.finalizarBiometria.emit();
    }
    excluir() {
        this.excluirFicha.emit();
    }
    abrirModalSobreAppOmniMais() {
        this.modal.show(ModalInfoAppOmniComponent, Object.assign({}, globals.MODAL_PARAMS));
    }
}
